module.exports = __webpack_public_path__ + "static/media/fontsize.fad3fd1a.svg";